<ng-container *ngIf="isEng">
    <div class="modal-header">
        <h3 (click)="dc()" class="modal-title" id="exampleModalLabel">{{config.title}}</h3>
        <button
                type="button"
                class="close"
                (click)="onContinue()"
        >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 1.00024L1 17.0002M1 1.00024L17 17.0002" stroke="#10082F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <p [innerHTML]="config.text | safeHtml: 'html'">
        </p>
    </div>
    <div class="modal-footer">
        <button class="action" type="button" (click)="onContinue()"
                >{{config.continueText}}
        </button>
        <button class="action action-light"  type="button" (click)="onStop()"
               >{{config.stopText}}
        </button>
    </div>
</ng-container>
<ng-container *ngIf="!isEng">
    <div class="modal-header">
        <h3 (click)="dc()" class="modal-title" >Ви впевнені, що хочете призупинити тест?</h3>
        <button
                type="button"
                class="close"
                (click)="onContinue()"
        >
            <img src="assets/icons/close-icon.png" alt="close-icon" />
        </button>
    </div>
    <div class="modal-body">
        <p>
            Якщо ви хочете призупинити тест, ви будете перенаправлені на головну сторінку.</p>
    </div>
    <div class="modal-footer">
        <button type="button" (click)="onContinue()"
                class="btn btn-link text-primary p-0">Продовжити тест
        </button>
        <button type="button" (click)="onStop()"
                class="btn btn-link text-secondary p-0">Призупинити
        </button>
    </div>
</ng-container>
